import useDownloadReport from "@saleor/hooks/useDownloadReport";
import { reportsDownload } from "@saleor/reports/utils/utils";
import _ from "lodash";
import Moment from "moment";

import { BatchStatus } from "../../../types/globalTypes";
import {
  formatCurrencyData,
  formatDateToFinanceDate,
  formatTextData,
  getCurrentTimestamp
} from "../../utils/misc";

export const getThreeMonths = () => ({
  from: Moment()
    .startOf("day")
    .subtract(3, "months")
    .format("YYYY-MM-DD HH:mm:ssZZ"),
  to: Moment()
    .add(1, "days")
    .format("YYYY-MM-DD HH:mm:ssZZ")
});

export const formatDate = (date: string) =>
  Moment.tz(new Date(date), "Asia/Manila").format("MM/DD/YYYY");

export const formatDateWithTime = (date: string) => Moment(date).format("LLL");

export const getBatchStatusValue = (batchStatus: string, username: string) => {
  switch (batchStatus) {
    case BatchStatus.FOR_MANAGER_APPROVAL:
      return "For Manager's Approval";
    case BatchStatus.FOR_TREASURY_2_PROCESSING:
      return "For Treasury's Processing";
    case BatchStatus.FOR_TREASURY_APPROVAL:
      return "For Treasury's Approval";
    case BatchStatus.COMPLETED:
      return "Completed";
    case BatchStatus.PROCESSED:
      return "Processed";
    case BatchStatus.REJECTED:
      return `Rejected by: ${username}`;
    case BatchStatus.CANCELLED:
      return `Cancelled by: ${username}`;
  }
};

// Filter report data
export const filterReportData = (reportData, reportFields) => {
  const textFields = ["mall_name", "legal_name", "brand_name"];
  const currencyFields = [
    "total_retail_price",
    "sale_discount_tenant",
    "sale_discount_sm",
    "sale_discount_total",
    "subtotal",
    "shipping_cost",
    "total_gross_transaction",
    "voucher_discount_tenant",
    "voucher_discount_sm",
    "discount_amount",
    "price_paid",
    "payment_fee",
    "payment_fee_vat",
    "payment_fee_adjustment",
    "payment_fee_adjustment_vat",
    "total_payment_fee",
    "payment_fee_witholding_tax",
    "delivery_fee_adjustment",
    "credit_card_witholding_tax",
    "other_adjustment",
    "net_settlement"
  ];
  const dateFields = ["created", "completed_at", "settlement_date"];

  const filteredData = reportData?.map(data => {
    delete data.__typename;

    // Format text data
    textFields.forEach(field => {
      data[field] = formatTextData(data?.[field], "UPC");
    });

    // Format text to prevent misplaced data
    currencyFields.forEach(field => {
      data[field] = formatCurrencyData(data?.[field]);
    });

    dateFields.forEach(field => {
      data[field] = formatDateToFinanceDate(data?.[field]);
    });

    // Filters object to remove extra column
    const erase = Object.keys(data).filter(
      e =>
        !Object.keys(reportFields).includes(e) &&
        Object.keys(reportFields).includes("mall_code")
    );

    // Deletes here
    for (const i in erase) {
      if ({}?.hasOwnProperty.call(erase, i)) {
        delete data[`${erase[i]}`];
      }
    }
    return data;
  });

  return filteredData;
};

export const getYear = (dateGeneratedYear: any) =>
  Moment.tz(new Date(dateGeneratedYear), "Asia/Manila").format("YYYY");

export const batchHistoryDetailsDownload = arr => {
  const groupedArr = Object.keys(_.groupBy(arr, "id"));

  return new Promise(resolve => {
    const val = filterReportData(
      _.groupBy(arr, "id")[Object.keys(_.groupBy(arr, "id"))[0]],
      reportsDownload.batchHistoryListPayouts.fields
    ).map(item => {
      Object.entries(item).forEach(([key, value]) => {
        if (
          typeof value === "string" &&
          value?.includes(",") &&
          !value?.match(/^".*?"$/)
        ) {
          item[key] = `"${value}"`;
        }
      });

      return item;
    });

    const fileNameBatchId = Object.values(
      _.groupBy(arr, "id")[groupedArr[0]]
    )[0].id;
    const fileNameMallCode = Object.values(
      _.groupBy(arr, "id")[groupedArr[0]]
    )[0].mall_code;
    const fileNameYear = getYear(
      Object.values(_.groupBy(arr, "id")[groupedArr[0]])[0].created
    );
    useDownloadReport(
      val,
      reportsDownload.batchHistoryListPayouts.fields,
      `${fileNameMallCode}_${fileNameYear}_${atob(fileNameBatchId)}`,
      `${fileNameMallCode}_${fileNameYear}_${atob(
        fileNameBatchId
      )}-${getCurrentTimestamp()}`,
      "csv"
    );

    resolve(true);
  });
};
